import {createTheme} from '@mui/material/styles';
import {useResponsive} from "./Modulo_Responsive/Hooks/useResponsive";


export const theme = createTheme({


    palette: {
        primary: {
            main: "#0082FB",
            light: '#131313',
        },
        secondary: {
            main: "#1C2B33",
        },
        info: {
            main: "#FED001",
        },
        success: {
            main: "#00FF1E"
        },
        action: {
            main: "#FFF"
        },


    },
    typography: {
        fontFamily: ['Roboto', 'sans-serif'].join(','),
        h1: {
            fontWeight: 700,
            lineHeight: 1.2,
            fontSize: 40, // tamaño base
            "@media (min-width:600px)": {
                fontSize: "2.5rem", // tablets
            },
            "@media (min-width:900px)": {
                fontSize: 72, // desktop
            },// puedes definir un color base
        },
        h2: {
            fontWeight: 700,
            lineHeight: 1.2,
            fontSize: 32, // tamaño base
            "@media (min-width:600px)": {
                fontSize: "2.5rem", // tablets
            },
            "@media (min-width:900px)": {
                fontSize: 48, // desktop
            },// puedes definir un color base
        },
        h3: {
            fontSize: 20,
            fontWeight: 600,
        },
        h4: {
            fontSize: 24,
            fontWeight: 400,
        },
        h5: {
            fontSize: 16,
            fontWeight: 600,
        },
        body1: {
            fontSize: 16,
            fontWeight: 400,
        },
        body2: {
            fontSize: 12,
            fontWeight: 500,
        },
        allVariants: {
            color: "#303741",
        },
    },
    components: {
        MuiGrid: {
            styleOverrides: {
                root: {
                    transition: "all .2s ease-in-out"
                }
            }
        },
        MuiTextField: {
            defaultProps: {
                fullWidth: true,
                variant: "filled",
                size: "medium"
            }
        },
        MuiFilledInput: {
            styleOverrides: {
                root: {
                    paddingLeft: 10,
                    paddingRight: 10,
                    borderRadius: 6,
                }
            }
        },
        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    borderRadius: 6
                }
            }
        },
        MuiButtonBase: {
            variants: [
                {
                    props: {variant: 'efecto'},
                    style: {
                        transition: 'all .1s ease-in-out',
                        borderRadius: 10,
                        '&: hover': {
                            marginTop: -6,
                            boxShadow: "0px 0px 0px 0px rgba(0,0,0,0)",

                        }
                    },
                },


            ],

        },
        MuiDialog: {
            styleOverrides: {
                paper: {
                    borderRadius: 10,
                    backgroundColor: '#131313',


                }
            }
        },
        MuiButton: {
            defaultProps: {
                variant: "contained",
            },
            styleOverrides: {
                root: {
                    borderRadius: 8,
                    fontWeight: 600,
                    paddingLeft: 32,
                    paddingRight: 32,
                    fontSize: 16,
                    textTransform: 'none'


                },
            }
        },
        MuiDrawer: {
            styleOverrides: {
                paper: {

                }
            }
        },



    }


})